import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconClipboard: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M12.75 1.5H9.615C9.3 0.63 8.475 0 7.5 0C6.525 0 5.7 0.63 5.385 1.5H2.25C1.425 1.5 0.75 2.175 0.75 3V13.5C0.75 14.325 1.425 15 2.25 15H12.75C13.575 15 14.25 14.325 14.25 13.5V3C14.25 2.175 13.575 1.5 12.75 1.5ZM7.5 1.5C7.9125 1.5 8.25 1.8375 8.25 2.25C8.25 2.6625 7.9125 3 7.5 3C7.0875 3 6.75 2.6625 6.75 2.25C6.75 1.8375 7.0875 1.5 7.5 1.5ZM9 12H3.75V10.5H9V12ZM11.25 9H3.75V7.5H11.25V9ZM11.25 6H3.75V4.5H11.25V6Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M12.75 1.5H9.615C9.3 0.63 8.475 0 7.5 0C6.525 0 5.7 0.63 5.385 1.5H2.25C1.425 1.5 0.75 2.175 0.75 3V13.5C0.75 14.325 1.425 15 2.25 15H12.75C13.575 15 14.25 14.325 14.25 13.5V3C14.25 2.175 13.575 1.5 12.75 1.5ZM7.5 1.5C7.9125 1.5 8.25 1.8375 8.25 2.25C8.25 2.6625 7.9125 3 7.5 3C7.0875 3 6.75 2.6625 6.75 2.25C6.75 1.8375 7.0875 1.5 7.5 1.5ZM9 12H3.75V10.5H9V12ZM11.25 9H3.75V7.5H11.25V9ZM11.25 6H3.75V4.5H11.25V6Z" />
	)
}

export default IconClipboard
